
import { Shield, UserCheck, LineChart, PieChart, Wallet, CreditCard, Building, ArrowDownUp, Layers, Lock } from "lucide-react";
import FeatureCard from "./FeatureCard";

const features = [
  {
    title: "Transaction Fraud Detection",
    description: "Identify suspicious banking transactions and payment patterns with our advanced AI analysis.",
    icon: ArrowDownUp,
    href: "/transaction-analysis",
  },
  {
    title: "Business Email Protection",
    description: "Protect against business email compromise and wire fraud attempts in financial correspondence.",
    icon: Shield,
    href: "/email-protection",
  },
  {
    title: "Customer Identity Verification",
    description: "Verify customer identities with multi-factor biometric analysis and document validation.",
    icon: UserCheck,
    href: "/identity-verification",
  },
  {
    title: "Payment Processing Security",
    description: "Secure payment gateways with real-time fraud detection and transaction monitoring.",
    icon: CreditCard,
    href: "/payment-security",
  },
  {
    title: "Financial Document Verification",
    description: "Authenticate financial statements, contracts, and banking documents for accuracy and tampering.",
    icon: Layers,
    href: "/document-verification",
  },
  {
    title: "Wealth Management Protection",
    description: "Safeguard investment accounts from unauthorized access and fraudulent transfer attempts.",
    icon: LineChart,
    href: "/investment-protection",
  },
  {
    title: "Corporate Banking Security",
    description: "Enterprise-grade security solutions for corporate banking platforms and treasury operations.",
    icon: Building,
    href: "/corporate-banking",
  },
  {
    title: "Digital Wallet Security",
    description: "Protect mobile banking and digital wallet applications from emerging fraud tactics.",
    icon: Wallet,
    href: "/digital-wallet",
  },
  {
    title: "Compliance & Risk Management",
    description: "Automate AML/KYC checks and regulatory compliance with AI-powered risk assessment.",
    icon: Lock,
    href: "/compliance",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-16 bg-white dark:bg-fraudeye-primary">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight">Banking & Fintech Fraud Prevention</h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Our platform offers advanced detection capabilities across all financial channels, powered by state-of-the-art AI models.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              href={feature.href}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
